var exports = {
  "kL": "ChannelInvitesTab.module__container___QmxrZk",
  "wx": "ChannelInvitesTab.module__header___QmxrZk",
  "h_": "ChannelInvitesTab.module__description___QmxrZk",
  "GC": "ChannelInvitesTab.module__buttonGroup___QmxrZk",
  "dc": "ChannelInvitesTab.module__spinnerContainer___QmxrZk",
  "sJ": "ChannelInvitesTab.module__invitesContainer___QmxrZk",
  "$h": "ChannelInvitesTab.module__invitesList___QmxrZk",
  "eu": "ChannelInvitesTab.module__inviteItems___QmxrZk",
};

module.exports = exports;
